export default __webpack_public_path__ + "static/media/primadonna6.05bba321.jpg";